export enum ChallengeTabType {
  TAB_BIKE = "TAB_BIKE",
  TAB_WALK = "TAB_WALK",
  TAB_MORE = "TAB_MORE",
}
